import React from 'react';
import { testimonials } from '../data/noklar';
export function Testimonials() {
  // Hidden until authentic NO KLAR reviews are added in data/noklar.ts (no buyers yet)
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-274" data-mp="3fycr5ou809bu">
      <div className="mx-auto max-w-6xl" data-id="element-275" data-mp="3azt4tnbpsviy">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-276" data-mp="3ayqaf5f6oaya">
          Vad <em className="text-red-700" data-id="element-277" data-mp="32061gvzfdfn9">lärarna</em> säger
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-278" data-mp="321z8wdhv43wb">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-279" data-mp="2s1qact0ee6dr">
              <div className="text-sm text-amber-500" aria-label="5 av 5 stjärnor" data-id="element-280" data-mp="2s3jfu4z9ykk6">
                <span aria-hidden="true" data-id="element-281" data-mp="v8wsy8so9ic6">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-282" data-mp="qa3qrciu5drb">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-283" data-mp="h8ax9aoyulpn">
                <span className="font-semibold text-slate-900" data-id="element-284" data-mp="m62soeotkpyl">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-285" data-mp="78k35a4bi8q3"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}